export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultMenuType = 'menu-sub-hidden';//'menu-default'; //'menu-sub-hidden', 'menu-hidden'
export const defaultStartPath = 'app/products';
export const defaultLocale = 'en';
export const localeOptions = [
  {id: 'en', name: 'English'},
  {id: 'es', name: 'Español'},
];
export const firebaseConfig = {
  apiKey: "AIzaSyBBksq-Asxq2M4Ot-75X19IyrEYJqNBPcg",
  authDomain: "gogo-react-login.firebaseapp.com",
  databaseURL: "https://gogo-react-login.firebaseio.com",
  projectId: "gogo-react-login",
  storageBucket: "gogo-react-login.appspot.com",
  messagingSenderId: "216495999563"
};
export const apiUrl = "http://localhost:9000/api/";
export const searchPath = "/app/pages/search";
export const servicePath = "https://api.coloredstrategies.com";
export const isMultiColorActive = true;
export const defaultColor = "light.purple";
export const defaultDirection = "ltr";
export const isDarkSwitchActive = true;
export const themeColorStorageKey = "__theme_color";
export const themeRadiusStorageKey = "__theme_radius";
export const isDemo = false;
export const APPLE_DEVICE = /iPad|iPhone|Macintosh|iPod/.test(navigator.userAgent) && 'ontouchend' in document;
export const ANDROID_DEVICE = !(/iPad|Macintosh|iPhone|iPod/.test(navigator.userAgent) && 'ontouchend' in document) && /Mobile/.test(navigator.userAgent);
export const IS_MOBILE_DEVICE = (/iPad|Macintosh|iPhone|iPod/.test(navigator.userAgent) && 'ontouchend' in document) || /Mobile/.test(navigator.userAgent);
export const IS_TAB = !!(window.matchMedia('(min-width: 768px)').matches && window.matchMedia('(min-height: 768px)').matches);
export const IS_IPAD = !!(APPLE_DEVICE && window.matchMedia('(min-width: 768px)').matches && window.matchMedia('(min-height: 768px)').matches);
export const IS_SAFARI = (/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent));
